import React, { useContext } from 'react';
import { ProductFruitsProvider } from '@cashfree-intl/coherent';
import PropTypes from 'prop-types';

import { MerchantContext } from 'contexts/MerchantContext';
import { MerchantDetailsContext } from 'contexts/MerchantDetailsContext';
import {
  createUserInfo,
  getAllCampaignNames,
} from 'containers/ProductTour/helper';
import { PROD } from 'utils/constants';

export const ProductTourProvider = ({ children }) => {
  const { productFruitCampaigns } = useContext(MerchantContext);
  const { merchantDetails } = useContext(MerchantDetailsContext);

  const productFruitId = process.env.PRODUCT_FRUIT_WORKSPACE;

  const enableProductFruits = !!productFruitCampaigns?.campaigns?.length;
  const campaigns = productFruitCampaigns?.campaigns;

  const envObj = process.env;
  const isProd = envObj.NODE_ENV === PROD;

  return (
    <ProductFruitsProvider
      workspaceCode={productFruitId}
      enableProductFruits={enableProductFruits}
      debug={!isProd}
      userProp={createUserInfo(merchantDetails, productFruitCampaigns)}
      campaigns={getAllCampaignNames(campaigns)}
    >
      {children}
    </ProductFruitsProvider>
  );
};

ProductTourProvider.propTypes = {
  children: PropTypes.node,
};
